module.exports = __webpack_public_path__ + "img/wf-finishing-position-2.0b505254.svg";